import React, { useEffect } from 'react';
import './Backdrop.css';
import { elakayAutoText } from "../../includes/pageInside/dataElakay";


const Backdrop = ({ 
  show, 
  click, 
  variant = 'default', // 'default', 'dark', 'blur', 'gradient'
  zIndex = 900,
  animated = false
}) => {
  // Lock scroll on body, html, and .elakayPage when backdrop is visible
  useEffect(() => {
    if (show) {
      // Get the elakayPage container
      const elakayPage = document.querySelector('.elakayPage');
      const scrollY = elakayPage ? elakayPage.scrollTop : window.scrollY;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      // Save current scroll position
      document.body.dataset.scrollY = scrollY;
      
      // Lock body and html
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      
      // Lock .elakayPage specifically (your main scrollable container)
      if (elakayPage) {
        elakayPage.style.overflow = 'hidden';
        elakayPage.dataset.scrollY = scrollY;
      }
      
      // Prevent layout shift from scrollbar disappearing
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      
      return () => {
        const savedScrollY = parseInt(document.body.dataset.scrollY || '0');
        
        // Restore body and html
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.documentElement.style.overflow = '';
        
        // Restore .elakayPage
        if (elakayPage) {
          elakayPage.style.overflow = '';
          elakayPage.scrollTop = savedScrollY;
        }
      };
    }
  }, [show]);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && show && click) {
        click();
      }
    };

    if (show) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [show, click]);

  if (!show) return null;

  return (
    <div
      className={`backdrop backdrop--${variant} ${animated ? 'backdrop--animated' : ''}`}
      style={{ zIndex }}
      onClick={click}
      role="button"
      tabIndex={-1}
      aria-label={elakayAutoText("h_113040593472f1", "Close overlay")}
      aria-hidden="true"
    >
      {/* Subtle grain texture overlay */}
      <div className="backdrop__noise" aria-hidden="true" />
      
      {/* Optional gradient orbs for 'gradient' variant */}
      {variant === 'gradient' && (
        <div className="backdrop__orbs" aria-hidden="true">
          <div className="backdrop__orb backdrop__orb--1" />
          <div className="backdrop__orb backdrop__orb--2" />
          <div className="backdrop__orb backdrop__orb--3" />
        </div>
      )}
    </div>
  );
};

export default Backdrop;
